export default function pathToObject(path: string, value: any) {
	return path.split('.').reduceRight((acc, key) => ({ [key]: acc }), value);
}
